import { AppData, TutorialStep } from "../interface/functionalityInterface";
import { CalculatorUnitProps } from "../interface/propTypesInterface";

export const dummyCalculator: CalculatorUnitProps = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "volume",
  branch: "Geometry",
  difficulty: "intermediate",
  inputs: [
    {
      id: "3c4ccc2b-4473-4ed8-80cf-2591c9d02800",
      name: "cube",
      baseQuantities: [
        {
          id: "8933c26f-f73e-44d4-b0fb-d4372fc7a531",
          name: "side",
          type: "text",
          value: "",
          symbol: "s",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "28ab2f6c-d69c-494e-942c-1f10e4d3117f",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-cube.620e60df6f13662928061f9913e972d1.svg",
      equation: "V=s³",
    },
    {
      id: "7eddfbee-1b8e-4ad3-9b5c-544d1ea4103e",
      name: "rectangular prism",
      baseQuantities: [
        {
          id: "c3bb5942-f2b9-496f-8b58-9dc6176867df",
          name: "length",
          type: "text",
          value: "",
          symbol: "l",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "480e2c01-5178-44c0-8654-c3f98dcd6570",
          name: "width",
          type: "text",
          value: "",
          symbol: "w",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "5d4a575e-c2aa-43f6-8ffc-df2f1f163e6e",
          name: "height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "ebb0b1b4-c5af-4cec-8e81-b7b895f59dc4",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-rectangularPrism.85d4cbd374eea9b95f6524928be91295.svg",
      equation: "V=l*w*h",
    },
    {
      id: "18c08e8d-3972-4e37-ac84-2c14408158e2",
      name: "cylinder",
      baseQuantities: [
        {
          id: "907cc14a-a10f-453c-a8d8-18c8bf392650",
          name: "radius",
          type: "text",
          value: "",
          symbol: "r",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "4b83ccd6-3e1c-425d-8561-a85bf3a0f651",
          name: "height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "7192bea4-8c7b-40e6-b650-2cbbe37fd44a",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-cylinder.4c04c6d1a79c4cf67e68cfc83737468a.svg",
      equation: "V=πr²*h",
    },
    {
      id: "fd0f98df-d316-45ff-8dec-8444173a35e7",
      name: "tube",
      baseQuantities: [
        {
          id: "4d180723-c72c-4622-9925-53dcde4faf26",
          name: "outer_diameter",
          type: "text",
          value: "",
          symbol: "Do",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "9b89daf8-7224-49c6-8982-759f5f897315",
          name: "inner_diameter",
          type: "text",
          value: "",
          symbol: "Di",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "9f4a02e9-55cb-4999-80f7-d6c54bd2ae36",
          name: "height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "3d8e0428-5e55-423a-92ea-56acd38a612d",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-tube.f2af41d02139b7bac3543a1580abf4d9.svg",
      equation: "πh/4(D₀-Dᵢ)",
    },
    {
      id: "e3a2913a-65d8-4533-a7ad-5186aa3dcffc",
      name: "cone",
      baseQuantities: [
        {
          id: "9b8464c5-864e-4d1b-b40a-b82f3de80f47",
          name: "radius",
          type: "text",
          value: "",
          symbol: "r",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "57b1fadf-be84-49f3-b1ce-5b3b348281af",
          name: "height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "512bcc60-59a8-4a11-b86f-3a24f7d54859",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-cone.895a15c150d9d65d8b55f2e5566cde66.svg",
      equation: "V=hπr²/3",
    },
    {
      id: "213cfe17-03c4-4df9-808f-57a9bf23c109",
      name: "sphere",
      baseQuantities: [
        {
          id: "dc05b526-f533-4554-85c7-c4b820cf745e",
          name: "radius",
          type: "text",
          value: "",
          symbol: "r",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "a83650f4-948e-4c56-8a88-1c804fba7006",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-sphere.df5ca0dc87ea03c3a5dece0ccde5d13f.svg",
      equation: "V=4πr³/3",
    },
    {
      id: "51b90e63-9c72-4174-8a04-344e0b427257",
      name: "capsule",
      baseQuantities: [
        {
          id: "92491abd-08e4-431f-952f-c014a5c51a4c",
          name: "radius",
          type: "text",
          value: "",
          symbol: "r",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
          toolTip: "cannot calculate radius",
        },
        {
          id: "1550e9e3-fc6a-4c0d-8373-0088c58e9b2b",
          name: "height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "64cca5be-17cf-4633-9572-1ca76563930b",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-capsule.7ae293849f19400a153f5604cfe6da19.svg",
      equation: "V=4πr³/3+hπr²",
    },
    {
      id: "be676edf-01dd-42c1-b2b1-56c77a61e829",
      name: "spherical_cap",
      baseQuantities: [
        {
          id: "bb908099-c658-4594-ac5f-dcd6cd239688",
          name: "sphere_radius",
          type: "text",
          value: "",
          symbol: "r",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "6f5c5d88-c6b7-45c4-9ae8-fe27cfc85aba",
          name: "cap_height",
          type: "text",
          value: "",
          symbol: "h",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
          toolTip: "cannot calculate cap height",
        },
        {
          id: "2739a30b-b3b9-4a38-9a28-118109fb2a8f",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-sphericalCap.850c045430ed734baea3c621122248b9.svg",
      equation: "V=πh²/3*(3r-h)",
    },
    {
      id: "ad126af8-dece-44ba-a907-915fddf9041d",
      name: "ellipsoid",
      baseQuantities: [
        {
          id: "29ea615a-309a-4e6f-abff-82414ca68d0c",
          name: "semi-axis_a",
          type: "text",
          value: "",
          symbol: "",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "7c4d8bc7-7e4a-4637-b00b-bc01d31bdc8e",
          name: "semi-axis_b",
          type: "text",
          value: "",
          symbol: "",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "d617b228-e2ca-4ff9-ac41-93ef21db53c1",
          name: "semi-axis_c",
          type: "text",
          value: "",
          symbol: "",
          baseUnit: "m",
          selectedUnit: "m",
          units: [
            {
              name: "m",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "km",
              fromConst: 1000,
              toConst: 0.001,
            },
            {
              name: "dm",
              fromConst: 0.1,
              toConst: 10,
            },
            {
              name: "cm",
              fromConst: 0.01,
              toConst: 100,
            },
            {
              name: "mm",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "inches",
              fromConst: 0.025399986284007407,
              toConst: 39.3701,
            },
            {
              name: "feet",
              fromConst: 0.3047999902464003,
              toConst: 3.28084,
            },
            {
              name: "miles",
              fromConst: 1609.34,
              toConst: 0.0006213727366498068,
            },
            {
              name: "yards",
              fromConst: 0.9144027578387177,
              toConst: 1.09361,
            },
            {
              name: "NM",
              fromConst: 1852,
              toConst: 0.0005399568034557236,
            },
            {
              name: "au",
              fromConst: 149600000000,
              toConst: 6.6844919786096254e-12,
            },
          ],
        },
        {
          id: "7d3db027-cfa8-41fd-a246-da3bd81f8de3",
          name: "volume",
          type: "numeric",
          value: "",
          symbol: "V",
          baseUnit: "m³",
          selectedUnit: "m³",
          units: [
            {
              name: "m³",
              fromConst: 1,
              toConst: 1,
            },
            {
              name: "dm³",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "cm³",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "mm³",
              fromConst: 1e-9,
              toConst: 1000000000,
            },
            {
              name: "l",
              fromConst: 0.001,
              toConst: 1000,
            },
            {
              name: "dl",
              fromConst: 0.0001,
              toConst: 10000,
            },
            {
              name: "cl",
              fromConst: 0.00001,
              toConst: 100000,
            },
            {
              name: "ml",
              fromConst: 0.000001,
              toConst: 1000000,
            },
            {
              name: "tbsp",
              fromConst: 0.000014999999999999999,
              toConst: 66666.66666666667,
            },
            {
              name: "tsp",
              fromConst: 0.000005,
              toConst: 200000,
            },
            {
              name: "in³",
              fromConst: 0.0000163870758410257,
              toConst: 61023.7,
            },
            {
              name: "ft³",
              fromConst: 0.028316819907857067,
              toConst: 35.3147,
            },
            {
              name: "yd³",
              fromConst: 0.7645552200007646,
              toConst: 1.30795,
            },
            {
              name: "US gal",
              fromConst: 0.003785412534257983,
              toConst: 264.172,
            },
            {
              name: "UK gal",
              fromConst: 0.004546095131586723,
              toConst: 219.969,
            },
            {
              name: "US oz",
              fromConst: 0.000029573549417401077,
              toConst: 33814,
            },
            {
              name: "UK oz",
              fromConst: 0.00002841304613426301,
              toConst: 35195.1,
            },
            {
              name: "US pt",
              fromConst: 0.0004731756711996896,
              toConst: 2113.38,
            },
            {
              name: "UK pt",
              fromConst: 0.000568262537292229,
              toConst: 1759.75,
            },
          ],
        },
      ],
      figure:
        "/static/media/calc-figure-volume-ellipsoid.d80c5770867ca450b42f2ef33a3b9a61.svg",
      equation: "V=4π/3*a*b*c",
    },
  ],
  calculate: [
    {
      name: "cube",
      equations: [
        {
          target: "volume",
          expression: "(side)^3",
        },
        {
          target: "side",
          expression: "(volume)^(1/3)",
        },
      ],
    },
    {
      name: "rectangular prism",
      equations: [
        {
          target: "volume",
          expression: "(length) * (width) * (height)",
        },
        {
          target: "length",
          expression: "(volume) / (width) / (height)",
        },
        {
          target: "width",
          expression: "(volume) / (length) / (height)",
        },
        {
          target: "height",
          expression: "(volume) / (length) / (width)",
        },
      ],
    },
    {
      name: "cylinder",
      equations: [
        {
          target: "volume",
          expression: "pi * (radius)^2 * (height)",
        },
        {
          target: "radius",
          expression: "((volume) / (height) / pi) ^ (1/2)",
        },
        {
          target: "height",
          expression: "(volume) / ((radius)^2 * pi)",
        },
      ],
    },
    {
      name: "tube",
      equations: [
        {
          target: "volume",
          expression:
            "pi * (1/4 * (outer_diameter)^2 - 1/4 * (inner_diameter)^2) * (height)",
        },
        {
          target: "outer_diameter",
          expression:
            "root(4/pi * ((volume)/(height) + pi/4 * (inner_diameter)^2))",
        },
        {
          target: "inner_diameter",
          expression:
            "root(4/pi * (pi/4 * (outer_diameter)^2 - (volume)/(height)))",
        },
        {
          target: "height",
          expression:
            "(volume) / (pi/4 * (outer_diameter)^2 - pi/4 * (inner_diameter)^2)",
        },
      ],
    },
    {
      name: "cone",
      equations: [
        {
          target: "volume",
          expression: "(pi * (radius)^2 * (height)) / 3",
        },
        {
          target: "radius",
          expression: "root(3/pi * (volume)/(height))",
        },
        {
          target: "height",
          expression: "3/(pi*(radius)^2) * (volume)",
        },
      ],
    },
    {
      name: "volume",
      equations: [
        {
          target: "volume",
          expression: "4/3 * pi * (radius) ^ 3",
        },
        {
          target: "radius",
          expression: "((3/(4*pi)) * (volume))^(1/3)",
        },
      ],
    },
    {
      name: "capsule",
      equations: [
        {
          target: "volume",
          expression: "4*pi/3 * (radius)^3 + (height)*pi*(radius)^2",
        },
        {
          target: "height",
          expression: "((volume) - 4*pi/3 * (radius)^3) / (pi * (radius)^2)",
        },
      ],
    },
    {
      name: "spherical_cap",
      equations: [
        {
          target: "volume",
          expression:
            "pi/3 * (cap_height)^2 * (3 * (sphere_radius) - (cap_height))",
        },
        {
          target: "sphere_radius",
          expression: "((3*(volume) / (pi*(cap_height)^2)) + (cap_height))/3",
        },
      ],
    },
    {
      name: "ellipsoid",
      equations: [
        {
          target: "volume",
          expression: "4*pi/3 * (semi-axis_a) * (semi-axis_b) * (semi-axis_c)",
        },
        {
          target: "semi-axis_a",
          expression: "3 * (volume) / (4*pi) / 1/((semi-axis_b)*(semi-axis_c))",
        },
        {
          target: "semi-axis_b",
          expression: "3 * (volume) / (4*pi) / 1/((semi-axis_a)*(semi-axis_c))",
        },
        {
          target: "semi-axis_c",
          expression: "3 * (volume) / (4*pi) / 1/((semi-axis_b)*(semi-axis_a))",
        },
      ],
    },
  ],
  id: "263f579e-44d7-47d2-9e9f-01896946f0df",
  selectedCalcMode: 2,
  noDecimals: 1,
  enableOperators: true,
  priorityList: [
    "907cc14a-a10f-453c-a8d8-18c8bf392650",
    "4b83ccd6-3e1c-425d-8561-a85bf3a0f651",
    "7192bea4-8c7b-40e6-b650-2cbbe37fd44a",
  ],
  addToReceipt: () => {},
  duplicateUnit: () => {},
  removeUnit: () => {},
  dragDrop: () => {},
};

export const tutorialSteps: TutorialStep[] = [
  {
    title: "Welcome to the academy!",
    text: "In the coming steps you will learn how to use the calculator! We will show the available features and how to best use them. After this turoial you will be a fully fledged calculator master!",
    nextButtonText: "I'm ready!",
    hideComponent: true,
    // isCompleted: true,
  },
  {
    title: "How to tutorial",
    text: 'To complete this tutorial you will need to perform certain tasks on the calculator below. After completion the calculator will give a little shake and you will be able to click the "next" button. Below is a hint bar, click it to reveal the hint!',
    helpText: "Hello I'm a hint bar!",
    nextButtonText: "Start tutorial!",
    eventListenerType: "click",
    task: () => {
      const hint = document.getElementById("tutorial-hint");
      console.log(hint);

      if (hint?.classList.contains("show")) {
        return true;
      }
      return false;
    },
    successText: "Good job, click next to begin your first taks!",
  },
  {
    title: "Calculator Figure",
    text: "Let's start simple. In the calculator unit below, there is a figure. Do you see it, it shows a cylinder? Sometimes when you click the figure of a calculator unit, it will reviel a secret mystery. Try it out!",
    eventListenerType: "click",
    task: () => {
      const flipped = document.getElementById("calc-flip-figure");
      if (flipped?.classList.contains("flip")) {
        return true;
      }
      return false;
    },
    successText:
      "Well done! When clicking the figure you can see that we have unveiled the equation formula! You can click the equation formula to flip back to the figure if you want!",
  },
  {
    title: "Calculator Title",
    text: 'Now why don\'t you try to change the title of the calculator? Below the label "calculator name" is an input field. A cylinder looks kind of like a battery, try to change the title to "battery"!',
    eventListenerType: "keyup",
    task: () => {
      const titleInput = document.getElementById(
        "calc-title-input"
      ) as HTMLInputElement;
      if (titleInput.value.includes("battery")) return true;
      return false;
    },
    successText:
      "Good job on making your own unique title! Remember you can change the title to whatever you want, whenever you want.",
  },
  {
    title: "Calculator Inputs",
    text: "Now lets make a simple calculation. We want to obtain a volume on the cylinder of 26.5 cubic meters. What radius and height gives a volume of 26.5? If you do not know, you can always click the hint bar below to unveil the answer.",
    helpText: "Try 1.3 meters on radius and 5 meters on height",
    eventListenerType: "input",
    task: () => {
      const volumeInputElement = document.getElementById(
        "7192bea4-8c7b-40e6-b650-2cbbe37fd44a"
      ) as HTMLInputElement;

      if (Number(volumeInputElement.value).toFixed(1).toString() === "26.5") {
        return true;
      }
      return false;
    },
    successText:
      "Good job! The calculator starts the calculating when it gets enough values. In this case we input radius and height, and that is enough for it to calculate the volume of a cylinder.",
  },
  {
    title: "Calculator Units",
    text: "Another neat feature is that you can change the unit of any field to whatever you want. Try to change the unit of the volume from cubic meters to liters",
    helpText: "Click the green button with 'm\u00b3' and select 'l'",
    eventListenerType: "change",
    task: (e) => {
      const value = e.target.value;
      if (value === "l") return true;
      return false;
    },
    successText:
      "Nice! You migh've noticed that when changing units, the value converts itself as well!",
  },
  {
    title: "Calculator Force Calculation",
    text: "As you've noticed, the calculator makes a calculation based on which inputs you change. But what if you want to explicitly calculate height? Try to click on the calculator icon to the right of the input field of 'height'.",
    eventListenerType: "click",
    task: function () {
      const forceCalc = document.getElementById(
        "lock-4b83ccd6-3e1c-425d-8561-a85bf3a0f651"
      );
      if (forceCalc?.classList.contains("locked")) {
        return true;
      }
      return false;
    },
    successText:
      'Well done! When the height input field is greyed out like that; It means that whatever new values we type into "radius" and/or "volume" will generate a new calculation on height!',
  },
  {
    title: "Calculator Toolbar Delete Calc",
    text: "Above the Calculator Figure is a toolbar, here you can see two buttons. The one to the left with a trashcan icon, will delete your calculator. In this tutorial, this calculator can't be deleted. But try to click it either way",
    eventListenerType: "click",
    task: (e) => {
      console.log(e.target);
      console.log(e.target.id);
      console.log(e.path);
      if (
        e.target.id === "calc-delete-button" ||
        e.path[1].id === "calc-delete-button" ||
        e.path[2].id === "calc-delete-button"
      ) {
        return true;
      }
      return false;
    },
    successText:
      "Perfect! Remeber that a deleted calculator is gone forever, so think wisely before clicking that button.",
  },
  {
    title: "Calculator Toolbar Clear Calc",
    text: "The other button, next to the delete calculator button in the top toolbar, will clear all the values in your calculator. Try to click it and watch as all your precious values will be gone forever!",
    eventListenerType: "click",
    task: (e) => {
      if (
        e.target.id === "calc-clear-button" ||
        e.path[1].id === "calc-clear-button" ||
        e.path[2].id === "calc-clear-button"
      ) {
        return true;
      }
      return false;
    },
    successText:
      "Slendid! Be careful with this button, when your values are removed you can't redo.",
  },
  {
    title: "Calculator Toolbar Receipt",
    text: 'Below the Calculator Mode is another toolbar. There you can find "Save to Receipt button". When clicked, your calculation will be save to a Receipt List. That list can be found in the calculator page. For now this is just a dummy, so go ahead and click the save to receipt button.',
    helpText: "Hover over buttons to get info of their purpose!",
    eventListenerType: "click",
    task: (e) => {
      if (
        e.target.id === "calc-receipt-button" ||
        e.path[1].id === "calc-receipt-button" ||
        e.path[2].id === "calc-receipt-button"
      ) {
        return true;
      }
      return false;
    },
    successText:
      "Good job! This feature is super important if you want to save you calculation and review later; Or maybe even share with someone!",
  },
  {
    title: "Calculator Toolbar Duplicate",
    text: "Next to the save to receipt button, is a duplicate calculator button. When clicked, you will create a copy of the existing calculator, with same values and title. Once again, this is just dummy, but try to click on it!",
    eventListenerType: "click",
    task: (e) => {
      if (
        e.target.id === "calc-duplicate-button" ||
        e.path[1].id === "calc-duplicate-button" ||
        e.path[2].id === "calc-duplicate-button"
      ) {
        return true;
      }
      return false;
    },
    successText:
      "Well done! This feature is neat, if you want to do a quick similiar calculation with some minor tweaked values.",
  },
  {
    title: "Calculator Decimals",
    text: 'Sometimes you want to have less or more decimals in your calculations, this is were decimal control comes handy. You see at the bottom toolbar, there is a plus and minus button and the text "no. decimals" Try to click the plus button and increase the amount of decimals allowed in the calculation.',
    eventListenerType: "click",
    task: (e) => {
      if (
        e.target.id === "calc-decimal-increase-button" ||
        e.path[1].id === "calc-decimal-increase-button" ||
        e.path[2].id === "calc-decimal-increase-button"
      ) {
        return true;
      }
      return false;
    },
    successText:
      "Well done! If you want you can type in some values in the input fields and you should see same amount of decimals as you've chosen.",
  },
  {
    title: "Calculator Calcmode",
    text: 'Now here is a beauty. The calcmode allows you to change the "mode" of your calculator, basically changing it to another calculator completely. Below the title you can see that we have the mode "cylinder". Why don\'t you go ahead and change it to "cone"?',
    eventListenerType: "change",
    task: (e) => {
      const value = e.target.value;

      if (value === "cone") {
        return true;
      }
      return false;
    },
    successText:
      "Good job! Remeber that all calculators are different. Some have lot's of modes, other have none. In our case, we have changed our calculator from being able to calculate the volume of a cylinder, to being able to calculate the volume of a cone!",
  },
  {
    title: "That is all",
    text: "Congratulations on finishing all the steps! We sincerly hope that eveything were easy enough and that you feel that you have learned enough to be able to handle the calculator on your own! If you still feel unsure, you can re-do this tutorial; Or even better, play around with the calculators!",
  },
];
